import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';

export default [
    {
        path: '/proto/digi_cert',
        name: ROUTE_NAME.CREATE_TEAM_DIGI_CERT,
        meta: {
            title: '数字证书使用协议',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "create_team" */ '@/pages/createTeam/digiCert.vue'),
            loading: Loading,
        }),
    },
    {
        path: '/contract/real_name_verify/:activityId',
        name: ROUTE_NAME.CONTRACT_REAL_NAME_VERIFY,
        meta: {
            title: '实名认证',
            scrollBehavior: 'restore',
            scrollDefaultPosition: 0,
            needBinding: true,
        },
        component: () => ({
            component: import(/* webpackChunkName: "create_team" */ '@/pages/createTeam/realnameVerify.vue'),
            loading: Loading,
        }),
    },
];
